import { Loader } from '.';

export const TableLoader = () => {
    return (
        <div className="p-7 flex items-center justify-center w-full">
            <Loader color="#1D79F2" />
        </div>
    );
};
